import { OSTICKET_HOST, OSTICKET_API_KEY, OSTICKET_PROXY, OSTICKET_ROOT_USER } from '../config';
import axios from 'axios';
import update from 'immutability-helper';

export const A = {
  FETCH_NEW_TICKET_REQUEST: 'FETCH_NEW_TICKET_REQUEST',
  FETCH_NEW_TICKET_SUCCESS: 'FETCH_NEW_TICKET_SUCCESS',
  FETCH_NEW_TICKET_FAILURE: 'FETCH_NEW_TICKET_FAILURE',

  FETCH_GET_TICKETS_REQUEST: 'FETCH_GET_TICKETS_REQUEST',
  FETCH_GET_TICKETS_SUCCESS: 'FETCH_GET_TICKETS_SUCCESS',
  FETCH_GET_TICKETS_FAILURE: 'FETCH_GET_TICKETS_FAILURE',

  FETCH_GET_TICKET_THREAD_REQUEST: 'FETCH_GET_TICKET_THREAD_REQUEST',
  FETCH_GET_TICKET_THREAD_SUCCESS: 'FETCH_GET_TICKET_THREAD_SUCCESS',
  FETCH_GET_TICKET_THREAD_FAILURE: 'FETCH_GET_TICKET_THREAD_FAILURE',

  FETCH_GET_TICKET_SAME_ORDER_REQUEST: 'FETCH_GET_TICKET_SAME_ORDER_REQUEST',
  FETCH_GET_TICKET_SAME_ORDER_SUCCESS: 'FETCH_GET_TICKET_SAME_ORDER_SUCCESS',
  FETCH_GET_TICKET_SAME_ORDER_FAILURE: 'FETCH_GET_TICKET_SAME_ORDER_FAILURE',

  FETCH_POST_MESSAGE_REQUEST: 'FETCH_POST_MESSAGE_REQUEST',
  FETCH_POST_MESSAGE_SUCCESS: 'FETCH_POST_MESSAGE_SUCCESS',
  FETCH_POST_MESSAGE_FAILURE: 'FETCH_POST_MESSAGE_FAILURE',

  FETCH_REGISTER_USER_REQUEST: 'FETCH_REGISTER_USER_REQUEST',
  FETCH_REGISTER_USER_SUCCESS: 'FETCH_REGISTER_USER_SUCCESS',
  FETCH_REGISTER_USER_FAILURE: 'FETCH_REGISTER_USER_FAILURE',

  FETCH_SET_UNREADED_STATUS_REQUEST: 'FETCH_SET_UNREADED_STATUS_REQUEST',
  FETCH_SET_UNREADED_STATUS_SUCCESS: 'FETCH_SET_UNREADED_STATUS_SUCCESS',
  FETCH_SET_UNREADED_STATUS_FAILURE: 'FETCH_SET_UNREADED_STATUS_FAILURE',

  FETCH_GET_UNREADED_COUNT_REQUEST: 'FETCH_GET_UNREADED_COUNT_REQUEST',
  SET_UNREADED_TICKET_COUNT: 'SET_UNREADED_TICKET_COUNT',
  FETCH_GET_UNREADED_COUNT_FAILURE: 'FETCH_GET_UNREADED_COUNT_FAILURE',

  FETCH_GET_TOPICS_REQUEST: 'FETCH_GET_TOPICS_REQUEST',
  SET_TOPICS: 'SET_TOPICS',
  FETCH_GET_TOPICS_FAILURE: 'FETCH_GET_TOPICS_FAILURE',

  FETCH_POST_RATE_REQUEST: 'FETCH_POST_RATE_REQUEST',
  FETCH_POST_RATE_SUCCESS: 'FETCH_POST_RATE_SUCCESS',
  FETCH_POST_RATE_FAILURE: 'FETCH_POST_RATE_FAILURE',

  FETCH_EXPORT_TICKET_REQUEST: 'FETCH_EXPORT_TICKET_REQUEST',
  FETCH_EXPORT_TICKET_SUCCESS: 'FETCH_EXPORT_TICKET_SUCCESS',
  FETCH_EXPORT_TICKET_FAILURE: 'FETCH_EXPORT_TICKET_FAILURE',
};

const osTicketConfig = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
};

const setOsticketHeaders = (getState) => {
  if (OSTICKET_PROXY) {
    osTicketConfig.headers['Authorization'] = 'Bearer ' + getState().auth.tokenData.access_token;
  } else {
    //Доступ к osticket без прокси. Из соображений безопасности OSTICKET_API_KEY на клиенте можно применять только для локальных и тестовых копий osTicket. Поскольку зная его получаем доступ к тикетам всех пользователей.
    osTicketConfig.headers['X-API-Key'] = OSTICKET_API_KEY;
    osTicketConfig.headers['User-Login'] = getState().auth.account.login;
    //ToDo по хорошему здесь надо считывать логин корневого пользователя из списка пользователей аккаунта. Но поскольку этот режим применяется только для отладки, пока сделана просто константа
    osTicketConfig.headers['Account'] = OSTICKET_ROOT_USER;
  }
};

export const fetchNewTicket = (data) => (dispatch, getState) => {
  dispatch(fetchNewTicketRequest());
  setOsticketHeaders(getState);
  return axios
    .post(OSTICKET_HOST + '/api/tickets.json', data, osTicketConfig)

    .then((res) => {
      dispatch(fetchNewTicketSuccess(res));
      return res;
    })

    .catch((err) => {
      dispatch(fetchNewTicketFailure(err));
      throw err;
    });
};

const fetchNewTicketRequest = () => ({
  type: A.FETCH_NEW_TICKET_REQUEST,
});

const fetchNewTicketSuccess = (response) => ({
  type: A.FETCH_NEW_TICKET_SUCCESS,
  ...response,
});

const fetchNewTicketFailure = (err) => ({
  type: A.FETCH_NEW_TICKET_FAILURE,
  err,
});

export const fetchGetTickets = (data) => (dispatch, getState) => {
  dispatch(fetchGetTicketsRequest());
  setOsticketHeaders(getState);
  return axios
    .post(OSTICKET_HOST + '/api/tickets/get.json', data, osTicketConfig)

    .then((res) => {
      dispatch(fetchGetTicketsSuccess(res));
      return res.data;
    })

    .catch((err) => {
      dispatch(fetchGetTicketsFailure(err));
      throw err;
    });
};

const fetchGetTicketsRequest = () => ({
  type: A.FETCH_GET_TICKETS_REQUEST,
});

const fetchGetTicketsSuccess = (response) => ({
  type: A.FETCH_GET_TICKETS_SUCCESS,
  ...response,
});

const fetchGetTicketsFailure = (err) => ({
  type: A.FETCH_GET_TICKETS_FAILURE,
  err,
});

export const fetchGetTicketThread = (data) => (dispatch, getState) => {
  dispatch(fetchGetTicketThreadRequest());
  setOsticketHeaders(getState);
  return axios
    .post(OSTICKET_HOST + '/api/tickets/thread.json', data, osTicketConfig)

    .then((res) => {
      dispatch(fetchGetTicketThreadSuccess(res));
      return res.data;
    })

    .catch((err) => {
      dispatch(fetchGetTicketThreadFailure(err));
      throw err;
    });
};

const fetchGetTicketThreadRequest = () => ({
  type: A.FETCH_GET_TICKET_THREAD_REQUEST,
});

const fetchGetTicketThreadSuccess = (response) => ({
  type: A.FETCH_GET_TICKET_THREAD_SUCCESS,
  ...response,
});

const fetchGetTicketThreadFailure = (err) => ({
  type: A.FETCH_GET_TICKET_THREAD_FAILURE,
  err,
});

export const fetchGetTicketSameOrder = (data) => (dispatch, getState) => {
  dispatch(fetchGetTicketSameOrderRequest());
  setOsticketHeaders(getState);
  return axios
    .post(OSTICKET_HOST + '/api/tickets/sameordernotickets.json', data, osTicketConfig)

    .then((res) => {
      dispatch(fetchGetTicketSameOrderSuccess(res));
      return res.data;
    })

    .catch((err) => {
      dispatch(fetchGetTicketSameOrderFailure(err));
      throw err;
    });
};

const fetchGetTicketSameOrderRequest = () => ({
  type: A.FETCH_GET_TICKET_SAME_ORDER_REQUEST,
});

const fetchGetTicketSameOrderSuccess = (response) => ({
  type: A.FETCH_GET_TICKET_SAME_ORDER_SUCCESS,
  ...response,
});

const fetchGetTicketSameOrderFailure = (err) => ({
  type: A.FETCH_GET_TICKET_SAME_ORDER_FAILURE,
  err,
});

export const fetchPostMessage = (data) => (dispatch, getState) => {
  dispatch(fetchPostMessageRequest());
  setOsticketHeaders(getState);
  return axios
    .post(OSTICKET_HOST + '/api/tickets/message.json', data, osTicketConfig)

    .then((res) => {
      dispatch(fetchPostMessageSuccess(res));
      return res;
    })

    .catch((err) => {
      dispatch(fetchPostMessageFailure(err));
      throw err;
    });
};

const fetchPostMessageRequest = () => ({
  type: A.FETCH_POST_MESSAGE_REQUEST,
});

const fetchPostMessageSuccess = (response) => ({
  type: A.FETCH_POST_MESSAGE_SUCCESS,
  ...response,
});

const fetchPostMessageFailure = (err) => ({
  type: A.FETCH_POST_MESSAGE_FAILURE,
  err,
});

export const fetchPostRate = (data) => (dispatch, getState) => {
  dispatch(fetchPostRateRequest());
  setOsticketHeaders(getState);
  return axios
    .post(OSTICKET_HOST + '/api/tickets/rate.json', data, osTicketConfig)

    .then((res) => {
      dispatch(fetchPostRateSuccess(res));
      return res;
    })

    .catch((err) => {
      dispatch(fetchPostRateFailure(err));
      throw err;
    });
};

const fetchPostRateRequest = () => ({
  type: A.FETCH_POST_RATE_REQUEST,
});

const fetchPostRateSuccess = (response) => ({
  type: A.FETCH_POST_RATE_SUCCESS,
  ...response,
});

const fetchPostRateFailure = (err) => ({
  type: A.FETCH_POST_RATE_FAILURE,
  err,
});

export const fetchRegisterUser = (data) => (dispatch, getState) => {
  dispatch(fetchRegisterUserRequest());
  setOsticketHeaders(getState);
  return axios
    .post(OSTICKET_HOST + '/api/users.json', data, osTicketConfig)

    .then((res) => {
      dispatch(fetchRegisterUserSuccess(res));
      return res;
    })

    .catch((err) => {
      dispatch(fetchRegisterUserFailure(err));
      throw err;
    });
};

const fetchRegisterUserRequest = () => ({
  type: A.FETCH_REGISTER_USER_REQUEST,
});

const fetchRegisterUserSuccess = (response) => ({
  type: A.FETCH_REGISTER_USER_SUCCESS,
  ...response,
});

const fetchRegisterUserFailure = (err) => ({
  type: A.FETCH_REGISTER_USER_FAILURE,
  err,
});

export const fetchSetUnreadedStstus = (data) => (dispatch, getState) => {
  dispatch(fetchSetUnreadedStstusRequest());
  setOsticketHeaders(getState);
  return axios
    .post(OSTICKET_HOST + '/api/tickets/unreaded.json', data, osTicketConfig)

    .then((res) => {
      dispatch(fetchSetUnreadedStstusSuccess(res));
      return res;
    })

    .catch((err) => {
      dispatch(fetchSetUnreadedStstusFailure(err));
      throw err;
    });
};

const fetchSetUnreadedStstusRequest = () => ({
  type: A.FETCH_SET_UNREADED_STATUS_REQUEST,
});

const fetchSetUnreadedStstusSuccess = (response) => ({
  type: A.FETCH_SET_UNREADED_STATUS_SUCCESS,
  ...response,
});

const fetchSetUnreadedStstusFailure = (err) => ({
  type: A.FETCH_SET_UNREADED_STATUS_FAILURE,
  err,
});

export const fetchGetUnreadedTicketCount = () => (dispatch, getState) => {
  dispatch(fetchGetUnreadedTicketCountRequest());
  setOsticketHeaders(getState);
  return axios
    .post(OSTICKET_HOST + '/api/tickets/getunreaded.json', { param: '' }, osTicketConfig)

    .then((res) => {
      const count = res.data.unreadedCount;
      dispatch(setUnreadedTicketCount(count));
      return count;
    })

    .catch((err) => {
      dispatch(fetchGetUnreadedTicketCountFailure(err));
      //Функция вспомогательная поэтому в случае ошибки в ней ничего не делаем
    });
};

const fetchGetUnreadedTicketCountRequest = () => ({
  type: A.FETCH_GET_UNREADED_COUNT_REQUEST,
});

export const setUnreadedTicketCount = (unreadedCount) => ({
  type: A.SET_UNREADED_TICKET_COUNT,
  unreadedCount,
});

const fetchGetUnreadedTicketCountFailure = (err) => ({
  type: A.FETCH_GET_UNREADED_COUNT_FAILURE,
  err,
});

export const fetchGetTopics = () => (dispatch, getState) => {
  const topics = getState().tickets.topics;
  if (topics && topics.length) {
    return topics;
  }
  dispatch(fetchGetTopicsRequest());
  setOsticketHeaders(getState);
  return axios
    .post(OSTICKET_HOST + '/api/tickets/gettopics.json', { param: '' }, osTicketConfig)

    .then((res) => {
      const topics = res.data.account_not_found ? [] : res.data;
      dispatch(setTopics(topics));
      return topics;
    })

    .catch((err) => {
      dispatch(fetchGetTopicsFailure(err));
      //Функция вспомогательная поэтому в случае ошибки в ней ничего не делаем
    });
};

const fetchGetTopicsRequest = () => ({
  type: A.FETCH_GET_TOPICS_REQUEST,
});

export const setTopics = (topics) => ({
  type: A.SET_TOPICS,
  topics,
});

const fetchGetTopicsFailure = (err) => ({
  type: A.FETCH_GET_TOPICS_FAILURE,
  err,
});

export const fetchExportTickets = (data) => (dispatch, getState) => {
  dispatch(fetchExportTicketsRequest());
  setOsticketHeaders(getState);

  return axios
    .post(OSTICKET_HOST + '/api/tickets/exportreport.json', data, {
      ...osTicketConfig,
      responseType: 'blob',
    })

    .then((res) => {
      // Create blob link to download
      const url = window.URL.createObjectURL(res.data);
      dispatch(fetchExportTicketsSuccess(url));
      return url;
    })

    .catch((err) => {
      dispatch(fetchExportTicketsFailure(err));
      throw err;
    });
};

const fetchExportTicketsRequest = () => ({
  type: A.FETCH_EXPORT_TICKET_REQUEST,
});

const fetchExportTicketsSuccess = (response) => ({
  type: A.FETCH_EXPORT_TICKET_SUCCESS,
  ...response,
});

const fetchExportTicketsFailure = (err) => ({
  type: A.FETCH_EXPORT_TICKET_FAILURE,
  err,
});
